<template>
  <v-container>
    <v-row>
      <v-progress-linear v-if="loading" indeterminate color="blue"></v-progress-linear>
      <v-col class="text-center">
        <v-badge overlap :bottom="true" color="white">
          <template v-slot:badge>
            <input type="file" style="display: none" ref="fileInput" @change="handleImageChange" accept="image/*">
            <v-icon dark small color="#00B3FF" @click="openFileInput">mdi-camera</v-icon>
          </template>
          <v-avatar size="120">
            <img v-if="selectedImageFile" :src="getObjectURL(selectedImageFile)" />
            <img v-else-if="user.profile_image" :src="user.profile_image" />
            <img v-else :src="defaultImage" />
          </v-avatar>
        </v-badge>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col>
        <div class="full-name">{{ user.name }}</div>
        <div class="join-date" v-if="user.created_at != null">
          <v-icon>mdi-calendar</v-icon> Joined on {{ user.created_at }}
        </div>
      </v-col>
    </v-row>
    <v-row class="text-center d-flex align-center justify-center mb-5" v-if="false">
      <v-card class="ma-2 custom-card">
        <h3 class="card-number" style="color: #00B3FF;">0</h3>
        <h5>Tasks</h5>
      </v-card>
      <v-card class="ma-2 custom-card">
        <h3 class="card-number" style="color: #00B3FF;">0%</h3>
        <h5>Rate</h5>
      </v-card>
    </v-row>
    <v-dialog v-model="confirmationDialog" max-width="400px" :persistent="true">
      <v-card>
        <v-card-title>Confirm Upload</v-card-title>
        <v-card-text>Are you sure you want to upload the selected image?</v-card-text>
        <v-card-actions>
          <v-btn @click="cancelUpload">Cancel</v-btn>
          <v-btn @click="confirmUpload" color="primary">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
    selectedImageFile: null,
    confirmationDialog: false,
  }),
  props: ["loading", "user"],
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleImageChange(event) {
      this.selectedImageFile = event.target.files[0];
      this.confirmationDialog = true;
    },
    cancelUpload() {
      this.selectedImageFile = null;
      this.confirmationDialog = false;
    },
    confirmUpload() {
      this.$emit("profileImageSelected", this.selectedImageFile);
      this.confirmationDialog = false;
    },
    getObjectURL(file) {
      return URL.createObjectURL(file);
    },
  },
};
</script>

<style scoped>
.full-name {
  font-size: 18px;
  font-weight: bold;
}

.join-date {
  font-size: 14px;
  color: #555;
}

.custom-card {
  height: 70px;
  width: 70px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.card-number {
  color: inherit;
}
</style>
